import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';
import { useContract } from '../../contracts';

export const PaymentNotification: React.FC = () => {
    const { t } = useTranslation('payment-notification');
    const { data: contracts, isLoading } = useContract();
    const [close, setClose] = useState<boolean>(true);

    if (isLoading || !contracts?.length) {
        return null;
    }
    return (
        <Notification
            testId={'payment-notification-test'}
            status={NotificationStatus.info}
            headline={t('headline')}
            visible={close}
            showCloseButton
            onCloseClick={() => setClose(false)}
        >
            <p>{t('paragraph1')}</p>
            <p>{t('paragraph2')}</p>
        </Notification>
    );
};
